module.exports = __webpack_public_path__ + "img/venkovni_posezeni.488cccf4.jpg";